@let data = correlation();
@let color = qualityColor();
@let isSmall = small();
@let isPrimaryColor = primaryColor();

<div class="flex items-center gap-3">
  <div class="size-[2.75rem] rounded-lg bg-(--p-neutral-500) flex items-center justify-center shrink-0"
       [ngClass]="{
         '!size-[2.25rem]': isSmall,
       }">
    <gc-ld-correlation-type-icon [correlationType]="data.correlationType" [correlationStateStatus]="data.qualityStatus" size="1.75rem"></gc-ld-correlation-type-icon>
  </div>

  <div class="flex flex-col grow-1 gap-[0.5rem] self-end">
    <div class="flex items-baseline gap-[0.375rem]"
         [ngClass]="isPrimaryColor ? 'text-(--p-primary-500)' : 'text-white'">
      <span class="text-[1.25rem] font-bold leading-none"
        [ngClass]="{
          '!text-[1rem]': isSmall,
        }"
        translate="@@shared-percentage"
        [translateParams]="{I18N_VAR_VALUE: data.quality}">
      </span>

      <span
        class="text-[0.6875rem] font-[500]"
        [ngClass]="{
          'text-(--p-primary-500)': isPrimaryColor,
          'text-white': !isPrimaryColor,
          '!text-[0.625rem]': isSmall,
        }"
        translate="@@shared-quality__text">
      </span>
    </div>

    <p-progressbar class="flex flex-1"
      styleClass="!h-[0.375rem] !w-full !max-w-[10.25rem] !min-w-[5.625rem] flex-1 !bg-transparent"
      [style]="{'border-color': color}"
      [color]="color"
      [value]="data.quality ?? 0"
      [showValue]="false">
    </p-progressbar>
  </div>
</div>